/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ActivationModel,
    ActivationModelFromJSON,
    ActivationModelToJSON,
    ActivationWithUpdateModel,
    ActivationWithUpdateModelFromJSON,
    ActivationWithUpdateModelToJSON,
    BasicModel,
    BasicModelFromJSON,
    BasicModelToJSON,
    BlockStatusViewModel,
    BlockStatusViewModelFromJSON,
    BlockStatusViewModelToJSON,
    ErrorModel,
    ErrorModelFromJSON,
    ErrorModelToJSON,
    ForgotPasswordViewModel,
    ForgotPasswordViewModelFromJSON,
    ForgotPasswordViewModelToJSON,
    Int32ValidatedModel,
    Int32ValidatedModelFromJSON,
    Int32ValidatedModelToJSON,
    LoginRequestModel,
    LoginRequestModelFromJSON,
    LoginRequestModelToJSON,
    LoginResponseModel,
    LoginResponseModelFromJSON,
    LoginResponseModelToJSON,
    LoginResponseModelValidatedModel,
    LoginResponseModelValidatedModelFromJSON,
    LoginResponseModelValidatedModelToJSON,
    LoginResponseWithMessageModelValidatedModel,
    LoginResponseWithMessageModelValidatedModelFromJSON,
    LoginResponseWithMessageModelValidatedModelToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RenterCompanyAgreementsViewModel,
    RenterCompanyAgreementsViewModelFromJSON,
    RenterCompanyAgreementsViewModelToJSON,
    RenterCompanyCreateModel,
    RenterCompanyCreateModelFromJSON,
    RenterCompanyCreateModelToJSON,
    RenterCompanyDetailViewModel,
    RenterCompanyDetailViewModelFromJSON,
    RenterCompanyDetailViewModelToJSON,
    RenterCompanyInfoModel,
    RenterCompanyInfoModelFromJSON,
    RenterCompanyInfoModelToJSON,
    RenterCompanyInfoUpdateModel,
    RenterCompanyInfoUpdateModelFromJSON,
    RenterCompanyInfoUpdateModelToJSON,
    RenterCompanyPaymentInfoViewModel,
    RenterCompanyPaymentInfoViewModelFromJSON,
    RenterCompanyPaymentInfoViewModelToJSON,
    RenterCompanyPaymentUpdateModel,
    RenterCompanyPaymentUpdateModelFromJSON,
    RenterCompanyPaymentUpdateModelToJSON,
    RenterCompanyProfileCreateModel,
    RenterCompanyProfileCreateModelFromJSON,
    RenterCompanyProfileCreateModelToJSON,
    RenterCompanyProfileViewModel,
    RenterCompanyProfileViewModelFromJSON,
    RenterCompanyProfileViewModelToJSON,
    RenterCompanySearchModel,
    RenterCompanySearchModelFromJSON,
    RenterCompanySearchModelToJSON,
    RenterCompanyViewModelPagedDataModel,
    RenterCompanyViewModelPagedDataModelFromJSON,
    RenterCompanyViewModelPagedDataModelToJSON,
    RequestFormCreateWithRegisterModel,
    RequestFormCreateWithRegisterModelFromJSON,
    RequestFormCreateWithRegisterModelToJSON,
    ResetPasswordViewModel,
    ResetPasswordViewModelFromJSON,
    ResetPasswordViewModelToJSON,
    SaleRequestFormCreateWithRegisterModel,
    SaleRequestFormCreateWithRegisterModelFromJSON,
    SaleRequestFormCreateWithRegisterModelToJSON,
    SetPasswordModel,
    SetPasswordModelFromJSON,
    SetPasswordModelToJSON,
    SocialLoginRequestModel,
    SocialLoginRequestModelFromJSON,
    SocialLoginRequestModelToJSON,
    SocialLoginResponseModel,
    SocialLoginResponseModelFromJSON,
    SocialLoginResponseModelToJSON,
} from '../models';

export interface RenterCompanyActivateAccountPostRequest {
    activationModel?: ActivationModel;
}

export interface RenterCompanyActivatePostRequest {
    activationModel?: ActivationModel;
}

export interface RenterCompanyActivateWithUpdatePostRequest {
    activationWithUpdateModel?: ActivationWithUpdateModel;
}

export interface RenterCompanyChangeBlockStatusUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyCheckRenterUserPostRequest {
    body?: string;
}

export interface RenterCompanyForgotPasswordPostRequest {
    forgotPasswordViewModel?: ForgotPasswordViewModel;
}

export interface RenterCompanyGetBlockStatusUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyIdDeleteRequest {
    id: number;
}

export interface RenterCompanyIdGetRequest {
    id: number;
}

export interface RenterCompanyInfoUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyInfoUserIdPostRequest {
    userId: number;
    renterCompanyInfoUpdateModel?: RenterCompanyInfoUpdateModel;
}

export interface RenterCompanyPaymentInfoUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyPaymentInfoUserIdPostRequest {
    userId: number;
    renterCompanyPaymentUpdateModel?: RenterCompanyPaymentUpdateModel;
}

export interface RenterCompanyProfileUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyProfileUserIdPostRequest {
    userId: number;
    renterCompanyProfileCreateModel?: RenterCompanyProfileCreateModel;
}

export interface RenterCompanyRegisterWithRequestPostRequest {
    requestFormCreateWithRegisterModel?: RequestFormCreateWithRegisterModel;
}

export interface RenterCompanyRegisterWithSaleRequestPostRequest {
    saleRequestFormCreateWithRegisterModel?: SaleRequestFormCreateWithRegisterModel;
}

export interface RenterCompanyResendAccountActivationCodeUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyResendActivationCodeUserIdGetRequest {
    userId: number;
}

export interface RenterCompanyResetPasswordPostRequest {
    resetPasswordViewModel?: ResetPasswordViewModel;
}

export interface RenterCompanySearchPostRequest {
    renterCompanySearchModel?: RenterCompanySearchModel;
}

export interface RenterCompanySetPasswordPostRequest {
    setPasswordModel?: SetPasswordModel;
}

export interface RenterCompanySignInPostRequest {
    loginRequestModel?: LoginRequestModel;
}

export interface RenterCompanySignInSocialPostRequest {
    socialLoginRequestModel?: SocialLoginRequestModel;
}

export interface RenterCompanySignUpPostRequest {
    renterCompanyCreateModel?: RenterCompanyCreateModel;
}

export interface RenterCompanyUpdateAgreementsVersionsPostRequest {
    renterCompanyAgreementsViewModel?: RenterCompanyAgreementsViewModel;
}

/**
 * 
 */
export class RenterCompanyApi extends runtime.BaseAPI {

    /**
     * Captcha ( RenterActivate = renteractivate )
     */
    async renterCompanyActivateAccountPostRaw(requestParameters: RenterCompanyActivateAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/activate-account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivationModelToJSON(requestParameters.activationModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterActivate = renteractivate )
     */
    async renterCompanyActivateAccountPost(requestParameters: RenterCompanyActivateAccountPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseModel> {
        const response = await this.renterCompanyActivateAccountPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterActivate = renteractivate )
     */
    async renterCompanyActivatePostRaw(requestParameters: RenterCompanyActivatePostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ActivationModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/activate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivationModelToJSON(requestParameters.activationModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivationModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterActivate = renteractivate )
     */
    async renterCompanyActivatePost(requestParameters: RenterCompanyActivatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ActivationModel> {
        const response = await this.renterCompanyActivatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterActivate = renteractivate )
     */
    async renterCompanyActivateWithUpdatePostRaw(requestParameters: RenterCompanyActivateWithUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Int32ValidatedModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/activate-with-update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivationWithUpdateModelToJSON(requestParameters.activationWithUpdateModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Int32ValidatedModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterActivate = renteractivate )
     */
    async renterCompanyActivateWithUpdatePost(requestParameters: RenterCompanyActivateWithUpdatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Int32ValidatedModel> {
        const response = await this.renterCompanyActivateWithUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin
     */
    async renterCompanyChangeBlockStatusUserIdGetRaw(requestParameters: RenterCompanyChangeBlockStatusUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BlockStatusViewModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyChangeBlockStatusUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/change-block-status/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlockStatusViewModelFromJSON(jsonValue));
    }

    /**
     * Admin
     */
    async renterCompanyChangeBlockStatusUserIdGet(requestParameters: RenterCompanyChangeBlockStatusUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BlockStatusViewModel> {
        const response = await this.renterCompanyChangeBlockStatusUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterRequestForm = renterrequestform )
     */
    async renterCompanyCheckRenterUserPostRaw(requestParameters: RenterCompanyCheckRenterUserPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Int32ValidatedModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/check-renter-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Int32ValidatedModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterRequestForm = renterrequestform )
     */
    async renterCompanyCheckRenterUserPost(requestParameters: RenterCompanyCheckRenterUserPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Int32ValidatedModel> {
        const response = await this.renterCompanyCheckRenterUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin
     */
    async renterCompanyCompanyListGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<BasicModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/company-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasicModelFromJSON));
    }

    /**
     * Admin
     */
    async renterCompanyCompanyListGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<BasicModel>> {
        const response = await this.renterCompanyCompanyListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterForgotPassword = renterforgotpassword )
     */
    async renterCompanyForgotPasswordPostRaw(requestParameters: RenterCompanyForgotPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Int32ValidatedModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/forgot-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForgotPasswordViewModelToJSON(requestParameters.forgotPasswordViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Int32ValidatedModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterForgotPassword = renterforgotpassword )
     */
    async renterCompanyForgotPasswordPost(requestParameters: RenterCompanyForgotPasswordPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Int32ValidatedModel> {
        const response = await this.renterCompanyForgotPasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin
     */
    async renterCompanyGetBlockStatusUserIdGetRaw(requestParameters: RenterCompanyGetBlockStatusUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BlockStatusViewModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyGetBlockStatusUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/get-block-status/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlockStatusViewModelFromJSON(jsonValue));
    }

    /**
     * Admin
     */
    async renterCompanyGetBlockStatusUserIdGet(requestParameters: RenterCompanyGetBlockStatusUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BlockStatusViewModel> {
        const response = await this.renterCompanyGetBlockStatusUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Customer, Admin
     */
    async renterCompanyIdDeleteRaw(requestParameters: RenterCompanyIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling renterCompanyIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Customer, Admin
     */
    async renterCompanyIdDelete(requestParameters: RenterCompanyIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<boolean> {
        const response = await this.renterCompanyIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin
     */
    async renterCompanyIdGetRaw(requestParameters: RenterCompanyIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyDetailViewModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling renterCompanyIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyDetailViewModelFromJSON(jsonValue));
    }

    /**
     * Admin
     */
    async renterCompanyIdGet(requestParameters: RenterCompanyIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyDetailViewModel> {
        const response = await this.renterCompanyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin, Customer
     */
    async renterCompanyInfoUserIdGetRaw(requestParameters: RenterCompanyInfoUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyInfoModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyInfoUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/info/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyInfoModelFromJSON(jsonValue));
    }

    /**
     * Admin, Customer
     */
    async renterCompanyInfoUserIdGet(requestParameters: RenterCompanyInfoUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyInfoModel> {
        const response = await this.renterCompanyInfoUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin, Customer
     */
    async renterCompanyInfoUserIdPostRaw(requestParameters: RenterCompanyInfoUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyInfoUpdateModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyInfoUserIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/info/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenterCompanyInfoUpdateModelToJSON(requestParameters.renterCompanyInfoUpdateModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyInfoUpdateModelFromJSON(jsonValue));
    }

    /**
     * Admin, Customer
     */
    async renterCompanyInfoUserIdPost(requestParameters: RenterCompanyInfoUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyInfoUpdateModel> {
        const response = await this.renterCompanyInfoUserIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin, Customer
     */
    async renterCompanyPaymentInfoUserIdGetRaw(requestParameters: RenterCompanyPaymentInfoUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyPaymentInfoViewModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyPaymentInfoUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/payment-info/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyPaymentInfoViewModelFromJSON(jsonValue));
    }

    /**
     * Admin, Customer
     */
    async renterCompanyPaymentInfoUserIdGet(requestParameters: RenterCompanyPaymentInfoUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyPaymentInfoViewModel> {
        const response = await this.renterCompanyPaymentInfoUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin, Customer
     */
    async renterCompanyPaymentInfoUserIdPostRaw(requestParameters: RenterCompanyPaymentInfoUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyPaymentUpdateModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyPaymentInfoUserIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/payment-info/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenterCompanyPaymentUpdateModelToJSON(requestParameters.renterCompanyPaymentUpdateModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyPaymentUpdateModelFromJSON(jsonValue));
    }

    /**
     * Admin, Customer
     */
    async renterCompanyPaymentInfoUserIdPost(requestParameters: RenterCompanyPaymentInfoUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyPaymentUpdateModel> {
        const response = await this.renterCompanyPaymentInfoUserIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin, Customer
     */
    async renterCompanyProfileUserIdGetRaw(requestParameters: RenterCompanyProfileUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyProfileViewModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyProfileUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/profile/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyProfileViewModelFromJSON(jsonValue));
    }

    /**
     * Admin, Customer
     */
    async renterCompanyProfileUserIdGet(requestParameters: RenterCompanyProfileUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyProfileViewModel> {
        const response = await this.renterCompanyProfileUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin, Customer
     */
    async renterCompanyProfileUserIdPostRaw(requestParameters: RenterCompanyProfileUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyProfileCreateModel>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyProfileUserIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/profile/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenterCompanyProfileCreateModelToJSON(requestParameters.renterCompanyProfileCreateModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyProfileCreateModelFromJSON(jsonValue));
    }

    /**
     * Admin, Customer
     */
    async renterCompanyProfileUserIdPost(requestParameters: RenterCompanyProfileUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyProfileCreateModel> {
        const response = await this.renterCompanyProfileUserIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterRequestForm = renterrequestform )
     */
    async renterCompanyRegisterWithRequestPostRaw(requestParameters: RenterCompanyRegisterWithRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseWithMessageModelValidatedModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/register-with-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestFormCreateWithRegisterModelToJSON(requestParameters.requestFormCreateWithRegisterModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseWithMessageModelValidatedModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterRequestForm = renterrequestform )
     */
    async renterCompanyRegisterWithRequestPost(requestParameters: RenterCompanyRegisterWithRequestPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseWithMessageModelValidatedModel> {
        const response = await this.renterCompanyRegisterWithRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterRequestForm = renterrequestform )
     */
    async renterCompanyRegisterWithSaleRequestPostRaw(requestParameters: RenterCompanyRegisterWithSaleRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseWithMessageModelValidatedModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/register-with-sale-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaleRequestFormCreateWithRegisterModelToJSON(requestParameters.saleRequestFormCreateWithRegisterModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseWithMessageModelValidatedModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterRequestForm = renterrequestform )
     */
    async renterCompanyRegisterWithSaleRequestPost(requestParameters: RenterCompanyRegisterWithSaleRequestPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseWithMessageModelValidatedModel> {
        const response = await this.renterCompanyRegisterWithSaleRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterResendActivate = renterresendactivate )
     */
    async renterCompanyResendAccountActivationCodeUserIdGetRaw(requestParameters: RenterCompanyResendAccountActivationCodeUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyResendAccountActivationCodeUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/resend-account-activation-code/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Captcha ( RenterResendActivate = renterresendactivate )
     */
    async renterCompanyResendAccountActivationCodeUserIdGet(requestParameters: RenterCompanyResendAccountActivationCodeUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.renterCompanyResendAccountActivationCodeUserIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Captcha ( RenterResendActivate = renterresendactivate )
     */
    async renterCompanyResendActivationCodeUserIdGetRaw(requestParameters: RenterCompanyResendActivationCodeUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling renterCompanyResendActivationCodeUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/resend-activation-code/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Captcha ( RenterResendActivate = renterresendactivate )
     */
    async renterCompanyResendActivationCodeUserIdGet(requestParameters: RenterCompanyResendActivationCodeUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.renterCompanyResendActivationCodeUserIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Captcha ( RenterResetPassword = renterresetpassword )
     */
    async renterCompanyResetPasswordPostRaw(requestParameters: RenterCompanyResetPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordViewModelToJSON(requestParameters.resetPasswordViewModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Captcha ( RenterResetPassword = renterresetpassword )
     */
    async renterCompanyResetPasswordPost(requestParameters: RenterCompanyResetPasswordPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.renterCompanyResetPasswordPostRaw(requestParameters, initOverrides);
    }

    /**
     * Admin
     */
    async renterCompanySearchPostRaw(requestParameters: RenterCompanySearchPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RenterCompanyViewModelPagedDataModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenterCompanySearchModelToJSON(requestParameters.renterCompanySearchModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RenterCompanyViewModelPagedDataModelFromJSON(jsonValue));
    }

    /**
     * Admin
     */
    async renterCompanySearchPost(requestParameters: RenterCompanySearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RenterCompanyViewModelPagedDataModel> {
        const response = await this.renterCompanySearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterSignIn = rentersignin )
     */
    async renterCompanySetPasswordPostRaw(requestParameters: RenterCompanySetPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/set-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetPasswordModelToJSON(requestParameters.setPasswordModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterSignIn = rentersignin )
     */
    async renterCompanySetPasswordPost(requestParameters: RenterCompanySetPasswordPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseModel> {
        const response = await this.renterCompanySetPasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterSignIn = rentersignin )
     */
    async renterCompanySignInPostRaw(requestParameters: RenterCompanySignInPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/sign-in`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestModelToJSON(requestParameters.loginRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterSignIn = rentersignin )
     */
    async renterCompanySignInPost(requestParameters: RenterCompanySignInPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseModel> {
        const response = await this.renterCompanySignInPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( RenterSignIn = rentersignin )
     */
    async renterCompanySignInSocialPostRaw(requestParameters: RenterCompanySignInSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SocialLoginResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/sign-in-social`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SocialLoginRequestModelToJSON(requestParameters.socialLoginRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialLoginResponseModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterSignIn = rentersignin )
     */
    async renterCompanySignInSocialPost(requestParameters: RenterCompanySignInSocialPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SocialLoginResponseModel> {
        const response = await this.renterCompanySignInSocialPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Customer
     */
    async renterCompanySignOutGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/sign-out`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Customer
     */
    async renterCompanySignOutGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.renterCompanySignOutGetRaw(initOverrides);
    }

    /**
     * Captcha ( RenterSignUp = rentersignup )
     */
    async renterCompanySignUpPostRaw(requestParameters: RenterCompanySignUpPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseModelValidatedModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/sign-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenterCompanyCreateModelToJSON(requestParameters.renterCompanyCreateModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseModelValidatedModelFromJSON(jsonValue));
    }

    /**
     * Captcha ( RenterSignUp = rentersignup )
     */
    async renterCompanySignUpPost(requestParameters: RenterCompanySignUpPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseModelValidatedModel> {
        const response = await this.renterCompanySignUpPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Customer
     */
    async renterCompanySwitchToLessorDashboardGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/switch-to-lessor-dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseModelFromJSON(jsonValue));
    }

    /**
     * Customer
     */
    async renterCompanySwitchToLessorDashboardGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseModel> {
        const response = await this.renterCompanySwitchToLessorDashboardGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Customer
     */
    async renterCompanyUpdateAgreementsVersionsPostRaw(requestParameters: RenterCompanyUpdateAgreementsVersionsPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/update-agreements-versions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenterCompanyAgreementsViewModelToJSON(requestParameters.renterCompanyAgreementsViewModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Customer
     */
    async renterCompanyUpdateAgreementsVersionsPost(requestParameters: RenterCompanyUpdateAgreementsVersionsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.renterCompanyUpdateAgreementsVersionsPostRaw(requestParameters, initOverrides);
    }

    /**
     * Customer
     */
    async renterCompanyUserDetailGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<LoginResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/renter-company/user-detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseModelFromJSON(jsonValue));
    }

    /**
     * Customer
     */
    async renterCompanyUserDetailGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<LoginResponseModel> {
        const response = await this.renterCompanyUserDetailGetRaw(initOverrides);
        return await response.value();
    }

}
